var map = {
	"./ABARTH.png": 1150,
	"./AIWAYS.png": 1151,
	"./ALFA ROMEO.png": 1152,
	"./ALPINE.png": 1153,
	"./AUDI.png": 1154,
	"./BMW.png": 1155,
	"./BYD.png": 1156,
	"./CADILLAC.png": 1157,
	"./CHEVROLET.png": 1158,
	"./CITROEN.png": 1159,
	"./CUPRA.png": 1160,
	"./DACIA.png": 1161,
	"./DS.png": 1162,
	"./FIAT.png": 1163,
	"./FISKER.png": 1164,
	"./FORD.png": 1165,
	"./HONDA.png": 1166,
	"./HONGQI.png": 1167,
	"./HYUNDAI.png": 1168,
	"./INFINITI.png": 1169,
	"./ISUZU.png": 1170,
	"./IVECO.png": 1171,
	"./JAC.png": 1172,
	"./JAGUAR.png": 1173,
	"./JEEP.png": 1174,
	"./KIA.png": 1175,
	"./LANCIA.png": 1176,
	"./LAND ROVER.png": 1177,
	"./LEVC.png": 1178,
	"./LEXUS.png": 1179,
	"./LOTUS.png": 1180,
	"./MAN.png": 1181,
	"./MASERATI.png": 1182,
	"./MAXUS.png": 1183,
	"./MAZDA.png": 1184,
	"./MERCEDES-BENZ.png": 1185,
	"./MERCEDES.png": 1186,
	"./MG.png": 1187,
	"./MINI.png": 1188,
	"./MITSUBISHI.png": 1189,
	"./NIO.png": 1190,
	"./NISSAN.png": 1191,
	"./OPEL.png": 1192,
	"./ORA.png": 1193,
	"./PEUGEOT.png": 1194,
	"./POLESTAR.png": 1195,
	"./PORSCHE.png": 1196,
	"./RENAULT.png": 1197,
	"./SEAT.png": 1198,
	"./SKODA.png": 1199,
	"./SMART.png": 1200,
	"./SSANGYONG.png": 1201,
	"./SUBARU.png": 1202,
	"./SUZUKI.png": 1203,
	"./TESLA-(LOGOTYPE).png": 1204,
	"./TESLA.png": 1205,
	"./TOYOTA.png": 1206,
	"./VOLKSWAGEN.png": 1207,
	"./VOLVO.png": 1208,
	"./VOYAH.png": 1209,
	"./VW.png": 1210,
	"./XPENG.png": 1211,
	"./car-missing.png": 193,
	"./cart.png": 459,
	"./heart.png": 457,
	"./home.png": 458,
	"./missing-car.svg": 226
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1149;